import React from 'react';
import { Col } from 'react-bootstrap';

export const ProjectCard = ({
  title, description, seeSource, technologies0, technologies1, technologies2, technologies3, technologies4, seeLive, imgUrl, projectUrl, link1, link2,
}) => (
  <Col size={12} sm={6} md={4}>
    <a href={projectUrl} target="_blank" rel="noopener noreferrer">
      <div className="proj-imgbx">
        <img src={imgUrl} alt="" style={{ height: '220px', objectFit: 'cover' }} />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <p className="mb-1 desc" id="desc">{description}</p>
          <div className="mb-1">
            <span className="techs" id="techs">{technologies0}</span>
            <span className="techs" id="techs">{technologies1}</span>
            <span className="techs" id="techs">{technologies2}</span>
            <span className="techs" id="techs">{technologies3}</span>
            <span className="techs" id="techs">{technologies4}</span>
          </div>

          <div className="">
            <a href={link1} target="_blank" rel="noreferrer">
              <button className="px-2 py-1 m-2 mejora">{seeSource}</button>
            </a>

            <a href={link2} target="_blank" rel="noreferrer">
              <button className="px-2 py-1 m-2 mejora">{seeLive}</button>
            </a>
          </div>

        </div>
      </div>
    </a>
  </Col>
);
